import {
  Div,
  LinkedInIcon,
  Text2,
  TwitterIcon,
  Popover,
  AddPhotoIcon
} from "components/Base";
import { Link } from "react-router";
import React from "react";
import { connect } from "react-redux";
import { getters } from "../model";
import Gravatar from "components/Global/Gravatar";
import * as FIELD_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";
import { AttendeePhoto, WithFormInstanceProvider } from "ui-kit/Form/View";
import * as R from "ramda";
import { EDIT_PARTICIPANT_FORM_ID } from "../constants";
import { getProfilePhotoValue } from "../selectors";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(EDIT_PARTICIPANT_FORM_ID)),
  connect(state => ({
    bio: getters.bio(state),
    isEditingDetails: getters.isEditingDetails(state),
    accountId: getters.accountId(state),
    profilePhotoUrl: getProfilePhotoValue(state),
    visibleFieldIds: getters.visibleFieldIds(state),
    lockedfieldIds: getters.lockedFieldIds(state)
  }))
);

const Overlay = () => (
  <Div
    className="showOnHover"
    bg="primary5"
    style={{
      borderRadius: 3,
      position: "absolute",
      opacity: 0.4,
      right: 0,
      left: 0,
      bottom: 0,
      top: 0
    }}
  />
);

const Icon = () => (
  <AddPhotoIcon
    size={34}
    color="neutral0"
    className="showOnHover"
    style={{
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)"
    }}
  />
);

const InfoPanel = ({
  bio = {},
  isEditingDetails,
  accountId,
  profilePhotoUrl,
  visibleFieldIds,
  lockedfieldIds
}) => {
  const photoFieldId = accountId
    ? FIELD_IDS.ACCOUNTS.LOGO_URL
    : FIELD_IDS.CONTACTS.AVATAR_URL;

  const isPhotoFieldVisible = visibleFieldIds.includes(photoFieldId);
  const isPhotoFieldLocked = lockedfieldIds.includes(photoFieldId);
  const isPhotoFieldEditable =
    isPhotoFieldVisible && !isPhotoFieldLocked && isEditingDetails;

  return (
    <Div
      p={4}
      mb={3}
      display="row.flex-start.flex-start"
      style={{ border: "1px solid #E7E6EA", borderRadius: "6px" }}
      width={1}
    >
      {isPhotoFieldVisible ? (
        <Popover
          Label={({ onClick }) => (
            <Div
              onClick={isPhotoFieldEditable ? onClick : undefined}
              className={isPhotoFieldEditable ? "hoverContainer" : undefined}
              style={{
                position: "relative",
                height: "40px",
                marginRight: "16px"
              }}
            >
              <Gravatar size={40} url={profilePhotoUrl} />
              {isPhotoFieldEditable ? <Overlay /> : null}
              {isPhotoFieldEditable ? <Icon /> : null}
            </Div>
          )}
        >
          {() => (
            //{ closePopover }
            <AttendeePhoto
              fieldId={photoFieldId}
              iniValue={{
                url: profilePhotoUrl
              }}
            />
          )}
        </Popover>
      ) : null}
      <Div display="column.space-between.flex-start">
        <Div display="column.flex-start.flex-start">
          {bio.name ? (
            <Div color="black" fs={3} fw={3}>
              {bio.salutation && bio.salutation.length
                ? `${bio.salutation} `
                : ``}
              {bio.name}
            </Div>
          ) : null}
          {bio.company ? <Text2>{bio.company}</Text2> : null}
          {bio.title ? <Text2 mb={0.25}>{bio.title}</Text2> : null}
          {bio.honorific ? <Text2>{bio.honorific}</Text2> : null}
        </Div>
        <Div display="row.flex-start.center" mt={2} style={{ gap: "12px" }}>
          {bio.email ? (
            <Link
              onlyActiveOnIndex
              alt="Link to email"
              to={`mailto:${bio.email}`}
              style={{ color: "#494949" }}
              target="_blank"
            >
              <i className="material-icons" style={{ fontSize: "18px" }}>
                email
              </i>
            </Link>
          ) : null}
          {bio.website_url ? (
            <Link
              onlyActiveOnIndex
              alt="Link to website"
              to={bio.website_url}
              style={{ color: "#494949" }}
              target="_blank"
            >
              <i className="material-icons" style={{ fontSize: "18px" }}>
                link
              </i>
            </Link>
          ) : null}
          {bio.linkedin_url ? (
            <Link
              onlyActiveOnIndex
              alt="Link to LinkedIn profile"
              to={bio.linkedin_url}
              target="_blank"
            >
              <LinkedInIcon size={18} />
            </Link>
          ) : null}
          {bio.x_url ? (
            <Link
              onlyActiveOnIndex
              alt="Link to X profile"
              to={bio.x_url}
              target="_blank"
            >
              <TwitterIcon size={18} />
            </Link>
          ) : null}
        </Div>
      </Div>
    </Div>
  );
};

export default decorate(InfoPanel);
